import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { editCollectionRegister, handleChangeController } from '../../../redux/actions/form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import RadioButton from '@material-ui/core/Radio'
import { useCollection } from '../../../utility/hooks/useCollection'

export const Radio = (properties) => {

    const { name,
        label,
        className = '',
        containerClassname = 'mt-1',
        color = "primary",
        collection } = properties

    const dispatch = useDispatch()
    const { form } = useSelector(state => state)
    const nodeForm = useCollection().getCollectionNode(form, collection)
    const [chk, setChk] = useState(nodeForm[name])

    const handleRadioChange = () => {
        const newCollection = [...collection].slice(0, collection.length - 1)
        const lastCollection = [...collection].pop()
        const nodeForm = useCollection().getCollectionNode(form, newCollection, false, false)
        const newData = nodeForm.map((a, i) => ({ ...a, [name]: i === lastCollection }))
        dispatch(handleChangeController(newCollection, newData))
    }

    useEffect(() => { setChk(nodeForm[name]) }, [nodeForm])

    return (
        <div className={containerClassname} >
            {label && <label className="control-label d-flex justify-content-between ml-2">{label}</label>}
            <RadioButton
                type="radio"
                size="medium"
                className={`${className} ml-2`}
                name={name}
                checkedIcon={<FontAwesomeIcon icon={faCheckCircle} />}
                icon={<FontAwesomeIcon icon={faCircle} />}
                color={color}
                checked={chk}
                onChange={handleRadioChange}
            />
        </div>
    )
}